<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <!-- 数据筛选 -->
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="友链名称" prop="linkName">
        <el-input v-model="queryParams.linkName" placeholder="请输入友链名称" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="创建时间" >
        <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 表格操作 -->
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['system:link:add']" type="primary" plain size="mini" icon="el-icon-plus" @click="openModel(null)">新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['system:link:remove']" type="danger" plain size="mini" icon="el-icon-deleteItem" :disabled="multiple" @click="handleDelete">批量删除</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList" ></right-toolbar>
    </el-row>
    <!-- 表格展示 -->
    <el-table
      border
      :data="linkList"
      @selection-change="selectionChange"
      v-loading="loading"
      size="small"
    >
      <!-- 表格列 -->
      <el-table-column type="selection" width="55" />
      <el-table-column prop="linkAvatar" label="链接头像" align="center" width="180">
        <template slot-scope="scope">
          <img :src="scope.row.linkAvatar" width="40" height="40" alt="" />
        </template>
      </el-table-column>
      <el-table-column prop="linkName" label="链接名" align="center" />
      <el-table-column prop="linkAddress" label="链接地址" align="center" />
      <el-table-column prop="linkIntro" label="链接介绍" align="center" />
      <el-table-column prop="createTime" label="创建时间" width="200" align="center">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span class="ml4">{{ scope.row.createTime | dateTime }} </span>
        </template>
      </el-table-column>
      <!-- 列操作 -->
      <el-table-column label="操作" align="center" width="160">
        <template slot-scope="scope">
          <el-button v-hasPermi="['system:link:edit']" type="text" size="mini" icon="el-icon-edit" @click="openModel(scope.row)">编辑</el-button>
          <el-button v-hasPermi="['system:link:remove']" type="text" size="mini" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getList"
    />
    <!-- 添加对话框 -->
    <el-dialog :title="linkTitle" :visible.sync="open" width="600px" :close-on-click-modal="false" >
      <el-form ref="linkForm" label-width="90px" :model="linkForm" :rules="linkRules">
        <el-form-item label="链接名称" prop="linkName">
          <el-input  v-model="linkForm.linkName" />
        </el-form-item>
        <el-form-item label="链接头像" prop="linkAvatar">
          <el-input  v-model="linkForm.linkAvatar" />
        </el-form-item>
        <el-form-item label="链接介绍" prop="linkIntro">
          <el-input  v-model="linkForm.linkIntro" />
        </el-form-item>
        <el-form-item label="链接地址" prop="linkAddress">
          <el-input  v-model="linkForm.linkAddress" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submitForm">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getFriendLinkList,
  addFriendLink,
  updateFriendLink,
  removeFriendLink
} from "@/api/system/friendlink";
export default {
  created() {
    this.getList();
  },
  data: function() {
    return {
      loading: true,
      showSearch: true,
      open: false,
      // 非多个禁用
      multiple: true,
      linkIds: [],
      linkNameList: [],
      linkList: [],
      linkTitle: "",
      linkForm: {
        linkId: null,
        linkName: "",
        linkAvatar: "",
        linkIntro: "",
        linkAddress: ""
      },
      linkRules: {
        linkName: [
          { required: true, message: "请输入友链名称", trigger: "blur" }
        ],
        linkAvatar: [
          { required: true, message: "请输入友链头像", trigger: "blur" }
        ],
        linkIntro: [
          { required: true, message: "请输入友链介绍", trigger: "blur" }
        ],
        linkAddress: [
          { required: true, message: "请输入友链地址", trigger: "blur" }
        ]
      },
      dateRange: [],
      queryParams: {
        current: 1,
        size: 10,
        linkName: null,
        startTime: null,
        endTime: null
      },
      total: 0
    };
  },
  methods: {
    selectionChange(selection) {
      this.linkIds = selection.map(item => item.linkId);
      this.linkNameList = selection.map(item => item.linkName);
      this.multiple = !selection.length;
    },
    handleQuery(){
      this.queryParams.current = 1;
      this.getList();
    },
    resetQuery(){
      this.dateRange = [];
      this.queryParams.startTime=undefined;
      this.queryParams.endTime=undefined;
      this.resetForm("queryForm");
      this.handleQuery()
    },
    handleDelete(row) {
      let ids = this.linkIds;
      let names = this.linkNameList;
      if (row.linkId) {
        ids = [row.linkId];
        names = [row.linkName];
      }
      this.$modal.confirm('是否确认删除友链名称为"' + names + '"的数据项？').then(function() {
          return removeFriendLink(ids);
        }).then(() => {
          this.getList();
        }).catch(() => {});
    },
    reset(){
      this.linkForm ={
        linkId: null,
        linkName: "",
        linkAvatar: "",
        linkIntro: "",
        linkAddress: ""
      }
      this.resetForm('linkForm')
    },
    cancel(){
      this.open = false;
      this.reset()
    },
    openModel(link) {
      this.reset()
      if (link != null) {
        this.linkForm = JSON.parse(JSON.stringify(link));
        this.linkTitle = "修改友链";
      } else {
        this.linkTitle = "新增友链";
      }
      this.open = true;
    },
    submitForm() {
      this.$refs["linkForm"].validate(valid => {
        if (valid) {
          if(this.linkForm.linkId!=null){
            updateFriendLink(this.linkForm).then(res => {
              if (res.flag) {
                this.$modal.msgSuccess("修改友链成功");
              } else {
                this.$modal.msgError("修改友链失败");
              }
              this.getList();
              this.open = false;
            });
          }else {
            addFriendLink(this.linkForm).then(res => {
              if (res.flag) {
                this.$modal.msgSuccess("新增友链成功");
              } else {
                this.$modal.msgError("新增友链失败");
              }
              this.getList();
              this.open = false;
            });
          }
        }
      });
    },
    getList() {
      this.loading = true;
      if( Array.isArray(this.dateRange) && this.dateRange.length>0){
        this.queryParams.startTime=this.dateRange[0];
        this.queryParams.endTime=this.dateRange[1];
      }
      getFriendLinkList(this.queryParams).then(res => {
        this.linkList = res.rows;
        this.total = res.total;
        this.loading = false;
      });
    }
  }
};
</script>
